var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datepicker',{staticClass:"app-datepicker",attrs:{"value":_vm.input,"language":_vm.languages['fr'],"clear-button":""},on:{"selected":_vm.onSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }